<div class="d-flex flex-fill flex-column p-3">
    <dx-data-grid
        #dataGrid
        *ngIf="inventory"
        class="grid-fill h-100"
        [dataSource]="inventory"
        [showBorders]="true"
        [columnAutoWidth]="false"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onExporting)="onExporting($event)"
    >
        <dxi-column dataField="partNumber" caption="Part #" width="350"></dxi-column>
        <dxi-column dataField="builtDate" caption="Built" width="110"></dxi-column>
        <dxi-column dataField="inStockChange" caption="InStock Change" width="100"></dxi-column>
        <dxi-column dataField="partsPulled" caption="Parts Pulled" width="100"></dxi-column>
        <dxi-column dataField="partsReturned" caption="Parts Returned" width="100"></dxi-column>
        <dxi-column dataField="positiveAdjustmentForDeletion" caption="Pos. Adj. for Deletion" width="100"></dxi-column>
        <dxi-column dataField="negativeAdjustmentForDeletion" caption="Neg. Adj. for Deletion" width="100"></dxi-column>
        <dxi-column width="100"></dxi-column>

        <dxo-export [enabled]="true"></dxo-export>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
        <dxo-selection [mode]="'single'"></dxo-selection>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="inventoryByDate-grid"></dxo-state-storing>
        <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

        <div *dxTemplate="let cell of 'linkTemplate'">
            <a [routerLink]="[]" (click)="open(cell.data.orderLineDetail.orderLine.orderId)">{{ cell.value || '' }}</a>
        </div>

        <div *dxTemplate="let data of 'toolbarButtons'">
            <!-- <button  (click)="rekickOff()" [disabled]="!dataGrid.instance.getSelectedRowsData()[0]" class="btn btn-success ms-10">ReKickOff</button>
                    <button  (click)="getData()" class="btn btn-primary ms-10">Refresh Data</button> -->
        </div>
    </dx-data-grid>
</div>
